import * as mainActions from '../main/actions';
import * as mainSelectors from '../main/selectors';

import {
  CHANGE_ELEMENT_APPYING_STATUS,
  CHANGE_NEXTGEN_UI_STATUS,
  CHANGE_UPLOADING_FILE_STATUS,
  SET_ALERT_INFO,
  SET_FLYOUT_PANEL_HEIGHT,
} from '../nextgen/actions';

import { ELEMENTS_ACTION_CHANGE_ELEMENT } from '../elements/actions';
import canvas from '../canvas';
import { getSelectedImage } from '../canvas/selectors';
import { isLogoEditing } from '../uploadimage/logics';
import { logoEditingStatusEnum } from '../utils/constants';
import { nextGenFlyoutPanelEnum } from '../nextgen/constants';
import { previewActionType } from '../preview/actions';
import { studioItemType as studioItemTypeEnum } from '../main/constants';
import { templateActionType } from '../template/actions';
import { textActionType } from '../text/actions';
import userimage from '../userimage';

const userimageActions = userimage.actions;
const { userImageActionType } = userimage.actions;
const { canvasActionType } = canvas.actions;

const allowedActions = [
  // background step-edit actions
  canvasActionType.ADD_BACKGROUND_IMAGE,
  mainActions.ADD_TEMP_BACKGROUND_IMAGE,
  mainActions.REMOVE_TEMP_BACKGROUND_IMAGE,
  mainActions.UPDATE_TEMP_BACKGROUND_IMAGE,
  mainActions.CHANGE_LOGO_EDITING_STATUS,
  mainActions.HIDE_TRANSPARENCY_COVER,
  canvasActionType.SET_IMAGE_UI,
  templateActionType.ADD_RECENT_BACKGROUND,
  templateActionType.CHANGE_BACKGROUND_STEP,
  // logo step-edit actions
  canvasActionType.UPDATE_CANVAS_IMAGE,
  canvasActionType.ADD_NEW_LOGO,
  canvasActionType.CHANGE_STATUS_OF_ALL_TEXT,
  userImageActionType.RECENTART_INIT,
  userImageActionType.SET_APPLY_NOTICE_PROMPT,
  userImageActionType.APPLYNOTICE_TOGGLE,
  userImageActionType.SET_APPLY_NOTICE_SCROLL,
  canvasActionType.SET_ITEMSTYIE_ORIGIN_SIZE,
  canvasActionType.CHANGE_CROPRECT,
  canvasActionType.CHANGE_LOGO_DIRECTION,
  canvasActionType.DELETE_IMAGE,
  canvasActionType.CHANGE_LOGO_COLORS,
  canvasActionType.SAVE_IMAGE_ORIGIN_COLORS,
  canvasActionType.CHANGE_TO_TEMP,
  canvasActionType.SELECT_IMAGE_FOR_NONDIGITAL,
  canvasActionType.SELECT_IMAGE,
  canvasActionType.CHANGE_ALL_TEXT_COLOR_NON_DIGITAL,
  previewActionType.UPDATE_FULL_PREVIEW,
  canvasActionType.CHANGE_LOGO_STATUS,
  canvasActionType.CHANGE_ART_COLOR,
  canvasActionType.CHANGE_CROP_PARAMETER,
  canvasActionType.CHANGE_IMAGE_SIZE,
  canvasActionType.CHANGE_TO_UNSHARPENED,
  canvasActionType.CHANGE_TO_SHARPENED,
  canvasActionType.CHANGE_IMAGE_UI_STATUS,
  canvasActionType.PUSH_TO_UNDO_STACK,
  mainActions.SHOW_WAITING_COVER,
  mainActions.HIDE_WAITING_COVER,
  mainActions.SET_UPLOAD_PROGRESS,
  mainActions.SHOW_MESSAGE_BOX,
  mainActions.HIDE_MESSAGE_BOX,
  canvasActionType.CHANGE_CANVAS_RESIZE,
  canvasActionType.ADD_TEMP,
  mainActions.TOKENWARNING_POPUP_TOGGLE,
  mainActions.TOKENEXPIRATION_POPUP_TOGGLE,
  mainActions.INITIALIZE_CHARGEDETAILS,
  mainActions.SET_PARAMETER_TOKEN,
  mainActions.SET_ELEMENT_DRAG_FLAG,
  mainActions.IMPRINT_OPTION_UI_SET,
  textActionType.CHANGE_COLOR_NONDIGITAL,
  textActionType.CHANGE_NONDIGITAL_TEXT_LINE,
  ELEMENTS_ACTION_CHANGE_ELEMENT,
  mainActions.SET_NEW_UPLOAD_LOGO_FLAG,
  mainActions.SWITCH_SHOW_WARNING_MESSAGE_CONTAINER,
  SET_FLYOUT_PANEL_HEIGHT,
  SET_ALERT_INFO,
  CHANGE_UPLOADING_FILE_STATUS,
  CHANGE_ELEMENT_APPYING_STATUS,
  mainActions.SHOW_CONFIRM_DIALOG,
  mainActions.HIDE_CONFIRM_DIALOG,
];

const actionsForKeepingNoticeStatus = [
  canvasActionType.SET_IMAGE_UI,
  mainActions.SHOW_WAITING_COVER,
  mainActions.HIDE_WAITING_COVER,
  mainActions.TOKENWARNING_POPUP_TOGGLE,
  mainActions.TOKENEXPIRATION_POPUP_TOGGLE,
  mainActions.INITIALIZE_CHARGEDETAILS,
  mainActions.SET_PARAMETER_TOKEN,
  mainActions.SET_ELEMENT_DRAG_FLAG,
  previewActionType.UPDATE_FULL_PREVIEW,
  canvasActionType.CHANGE_CANVAS_RESIZE,
  userImageActionType.SET_APPLY_NOTICE_SCROLL,
  canvasActionType.SET_ITEMSTYIE_ORIGIN_SIZE,
];

const actionsForKeepingNoticeStatus_editUploadPanel = [
  userImageActionType.RECENTART_INIT,
  mainActions.HIDE_WAITING_COVER,
  userImageActionType.SET_APPLY_NOTICE_SCROLL,
  mainActions.SET_ELEMENT_DRAG_FLAG,
];
const LogoEditingMiddleware =
  ({ _, getState }) =>
  (next) =>
  (action) => {
    const state = getState();
    const editingStatus = mainSelectors.getLogoEditingStatus(state).currentStatus;

    // skip if DpiWarningButton status
    if (editingStatus === logoEditingStatusEnum.DpiWarningButton) {
      return next(action);
    }

    // skip if not in logo/background edit panels
    if (!isLogoEditing(editingStatus)) {
      //check if EditUpload panel is active
      const selectedImage = getSelectedImage(state);
      const studioItemType = mainSelectors.getStudioItemType(state);
      if (studioItemType === studioItemTypeEnum.digital && selectedImage) {
        // hide theApplyNotice if necessary
        if (!actionsForKeepingNoticeStatus_editUploadPanel.find((x) => x === action.type)) {
          next(userimageActions.applyNoticeToggle({ show: false, keepPromptText: true }));
          next(mainActions.switchShowWarningMessageContainer({ show: false }));
          console.log(`temp-upload-keep:${action.type}`);
        }
      }

      return next(action);
    }

    if (allowedActions.find((x) => x === action.type)) {
      //hide the warning message, but keep the message not changed
      if (
        !actionsForKeepingNoticeStatus.find((x) => x === action.type) &&
        editingStatus !== logoEditingStatusEnum.NonDigitalLogoColorPicker &&
        editingStatus !== logoEditingStatusEnum.DigitalLogoColorPicker
      ) {
        if (action.type === userImageActionType.APPLYNOTICE_TOGGLE) {
          next(userimageActions.applyNoticeToggle({ show: false, keepPromptText: true }));
        } else if (action.type !== mainActions.SWITCH_SHOW_WARNING_MESSAGE_CONTAINER) {
          next(userimageActions.applyNoticeToggle({ show: false, keepPromptText: true }));
          next(mainActions.switchShowWarningMessageContainer({ show: false }));
        }

        console.log(`temp-upload-keep:${action.type}`);
      }

      //perform the allowed action
      return next(action);
    } else {
      // nextgen: allow switch when editing Background/ScreenPrinted Logo
      if (action.type === CHANGE_NEXTGEN_UI_STATUS && action.payload.flyoutPanel) {
        const switchToPanel = action.payload.flyoutPanel.currentPanel;
        if (
          switchToPanel === nextGenFlyoutPanelEnum.BackgroundRemoveWhitePanel ||
          switchToPanel === nextGenFlyoutPanelEnum.BackgroundCropPanel ||
          switchToPanel === nextGenFlyoutPanelEnum.BackgroundRotatePanel ||
          switchToPanel === nextGenFlyoutPanelEnum.LogoRemoveWhitePanel ||
          switchToPanel === nextGenFlyoutPanelEnum.LogoCropPanel ||
          switchToPanel === nextGenFlyoutPanelEnum.LogoRotatePanel ||
          switchToPanel === nextGenFlyoutPanelEnum.LogoColorPanel ||
          switchToPanel === nextGenFlyoutPanelEnum.LogoColorPickerPanel ||
          switchToPanel === nextGenFlyoutPanelEnum.ScreenPrintedLogoColorPicker ||
          switchToPanel === nextGenFlyoutPanelEnum.EditImagePanel
        ) {
          return next(action);
        }
      } else if (
        action.type === CHANGE_NEXTGEN_UI_STATUS &&
        (action.payload.showUploadCover !== undefined || action.payload.showCanvasCover !== undefined)
      ) {
        return next(action);
      }


      //show warning message
      next(userimageActions.applyNoticeToggle({ show: true, keepPromptText: true }));
      console.log(`temp-upload-captured:${action.type}`);
      //reject the not-allowed action
      return null;
    }
  };

export default LogoEditingMiddleware;
